import { styled, component } from '../../../../utils/style';

export const StyledHeaderButton = styled()(component.div, 'StyledHeaderButton')`
	cursor: pointer;

	& > svg {
		height: 30px;
		width: 30px;
		transition: all 0.2s;
		fill: ${props => props.theme.primary.iconsColor};
	}

	& > img {
		max-height: 30px;
		max-width: 100%;
		min-width: 30px;
		margin: 0 5px;
	}
`;

export const TextButton = styled()(component.div, 'TextButton')`
	height: 30px;
	line-height: 30px;
	color: ${props => props.theme.primary.iconsColor};
	background-color: ${props => props.theme.primary.topnavColor};
	margin: 0 5px;
	cursor: pointer;
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/HeaderButton/styles.ts